import { useCallback, useEffect, useState } from "react";
import { usePlatformDesigner } from "@/lib/usePlatformDesigner";
import {
  readPlatformDesignerBuyerPreview,
  writePlatformDesignerBuyerPreview,
} from "@/lib/platformDesignerBuyerPreview";

export const PLATFORM_DESIGNER_BUYER_PREVIEW_EVENT = "visor:platform-designer-buyer-preview-changed";

export function usePlatformDesignerBuyerPreview() {
  const isPlatformDesigner = usePlatformDesigner();
  const [active, setActive] = useState(
    () => isPlatformDesigner && readPlatformDesignerBuyerPreview(),
  );

  useEffect(() => {
    if (!isPlatformDesigner) {
      if (readPlatformDesignerBuyerPreview()) {
        writePlatformDesignerBuyerPreview(false);
      }
      setActive(false);
      return;
    }
    setActive(readPlatformDesignerBuyerPreview());
  }, [isPlatformDesigner]);

  useEffect(() => {
    const sync = () => {
      setActive(isPlatformDesigner && readPlatformDesignerBuyerPreview());
    };
    window.addEventListener(PLATFORM_DESIGNER_BUYER_PREVIEW_EVENT, sync);
    return () => window.removeEventListener(PLATFORM_DESIGNER_BUYER_PREVIEW_EVENT, sync);
  }, [isPlatformDesigner]);

  return Boolean(isPlatformDesigner && active);
}

export function usePlatformDesignerBuyerPreviewActions() {
  const isPlatformDesigner = usePlatformDesigner();
  const buyerPreviewActive = usePlatformDesignerBuyerPreview();

  const setBuyerPreview = useCallback(
    (enabled) => {
      if (!isPlatformDesigner) return;
      const next = Boolean(enabled);
      writePlatformDesignerBuyerPreview(next);
      window.dispatchEvent(
        new CustomEvent(PLATFORM_DESIGNER_BUYER_PREVIEW_EVENT, { detail: { active: next } }),
      );
    },
    [isPlatformDesigner],
  );

  return {
    buyerPreviewActive,
    setBuyerPreview,
    enableBuyerPreview: () => setBuyerPreview(true),
    disableBuyerPreview: () => setBuyerPreview(false),
  };
}
